import Button from '@v2/shared/components/Button';
import Container from '@v2/shared/components/Container';
import { faLongArrowRight } from '@fortawesome/pro-regular-svg-icons';
import useUrlGenerator from '@v2/shared/lib/useUrlGenerator';
import billboard from './images/titles/billboard.png';
import theGuardian from './images/titles/the-guardian.jpg';
import pcWorld from './images/titles/pc-world.png';
import hollywoodReporter from './images/titles/hollywood-reporter.png';
import kiplingers from './images/titles/kiplingers.png';
import theWeek from './images/titles/the-week.png';

/**
 * A fixed editorial selection, as it was at the source.
 *
 * Unlike Magzter Gold's panel, which quotes each title's own price from the vendor's
 * api, this one is six static covers with no prices — so there is no client, no cache
 * and nothing to go stale. Its own covers, too: the files here are a different crop of
 * some of the same titles the hero uses.
 */
const TITLES: { src: string; title: string; className?: string }[] = [
  { src: billboard, title: 'Billboard' },
  { src: theGuardian, title: 'The Guardian Weekly' },
  { src: pcWorld, title: 'PC World' },
  { src: hollywoodReporter, title: 'Hollywood Reporter' },
  { src: kiplingers, title: "Kiplinger's Personal Finance", className: 'block lg:block' },
  { src: theWeek, title: 'The Week', className: 'block md:hidden lg:block' },
];

export default function TitlesPanel() {
  const { buildUrl } = useUrlGenerator();

  // Pages.ZinioUnlimitedMagazines, which moved off headless with this page's sibling
  // route. buildUrl keeps the storefront's base url on it, so AU's /au/ prefix survives.
  const browseUrl = buildUrl('/categories/zinio-unlimited');

  return (
    <div className="flex items-center justify-center py-14 bg-white lg:py-20">
      <Container className="flex flex-col items-center">
        <h2 className="text-3xl sm:text-4xl md:text-5xl mb-10 font-bold max-w-3xl text-center">
          1000s of popular titles
        </h2>
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 lg:grid-cols-6 gap-6 lg:gap-6 w-full mb-6">
          {TITLES.map((title) => (
            <div key={title.title} className={title.className}>
              <img src={title.src} alt={title.title} className="rounded-md w-full h-auto" />
              <div className="font-semibold text-md lg:text-md xl:text-lg">{title.title}</div>
            </div>
          ))}
        </div>
        <Button
          size="md"
          color="secondary"
          iconAfter={faLongArrowRight}
          onClick={() => {
            window.location.href = browseUrl;
          }}
        >
          View Available Magazines
        </Button>
      </Container>
    </div>
  );
}
